export function firebaseTimestampToDate(value: any) {
	const { _seconds, _nanoseconds } = value;
	return {
		seconds: _seconds,
		nanoseconds: _nanoseconds,
	};
}
